import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import TYPES from '@/constant/types.js'
import { Dialog } from "vant";
import CRMRouter from './crm';
import SurveyRouter from "./survey";
import ArchivesRouter from "./archives";
import InvestigationRouter from "./investigation";
import CommonFormRouter from "./commonForm";

import EmptyPage from '@/views/emptyPage.vue'
import {
	getTokenState,
	clearCrmAuthStorage,
	getCrmLoginPath,
	isCrmAuthRedirectRequest
} from "@/utils/auth";


const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);
const routes = [
	{
		path: "/",
		name: "Empty",
		mate: {
			title: "健恒医疗"
		},
		component: EmptyPage,
	},
	...SurveyRouter,
	...ArchivesRouter,
	...InvestigationRouter,
	...CommonFormRouter,
	...CRMRouter
];

const router = new VueRouter({
	mode: "history",
	base: process.env.VUE_APP_ASSET_BASE_URL,
	routes,
});

let authRedirecting = false;

function saveScrollPosition(to, from, isCrmRoute) {
	if (!from.meta || !from.meta.keepAlive) return;

	if (isCrmRoute) {
		if (to.name === 'crm-detail-hospital') {
			const $wrapper = document.querySelector('.crm-inhospital'); // 列表的外层容器 注意找到滚动的盒子
			const scrollTop = $wrapper ? $wrapper.scrollTop : 0;
			from.meta.scrollTop = scrollTop;
		} else {
			from.meta.scrollTop = 0;
		}
		return;
	}

	const $wrapper = document.querySelector('.testa'); // 列表的外层容器 注意找到滚动的盒子
	const scrollTop = $wrapper ? $wrapper.scrollTop : 0;
	from.meta.scrollTop = scrollTop;
}

function redirectToLogin() {
	authRedirecting = true;
	window.location.replace(getCrmLoginPath());
}

router.beforeEach(async (to, from, next) => {
	const isCrmRoute = to.fullPath.indexOf('/crm/') === 0 && !!to.meta && (to.meta.roles || []).length > 0;

	if (!isCrmRoute) {
		saveScrollPosition(to, from, false);
		next();
		return;
	}

	const isLoginPage = to.name === 'crm-login' || to.name === 'crm-pLogin';
	const token = localStorage.getItem(TYPES.STAFF_TOKEN);
	const tokenState = getTokenState(token);

	if (isLoginPage) {
		if (tokenState === 'expired') {
			clearCrmAuthStorage();
			store.commit('CLEAR_AUTH');
			next();
			return;
		}

		// redirectUri 是给第三方系统换 code 的授权入口，不能被登录态守卫拦掉
		if (tokenState !== 'missing' && !isCrmAuthRedirectRequest(to)) {
			next({ path: '/crm/home', replace: true });
			return;
		}

		next();
		return;
	}

	if (tokenState === 'missing' || tokenState === 'expired') {
		const expired = tokenState === 'expired';
		clearCrmAuthStorage();
		store.commit('CLEAR_AUTH');

		if (!authRedirecting) {
			authRedirecting = true;
			Dialog.alert({
				title: "提示",
				showConfirmButton: true,
				message: expired
					? '您的登录状态已过期，请重新登录。'
					: '您尚未登录，请先登录。',
				confirmButtonText: "重新登录",
				messageAlign: 'left'
			})
				.then(redirectToLogin)
				.catch(redirectToLogin);
		}
		return;
	}

	try {
		await store.dispatch("update_dict_info");
	} catch (e) {
		console.warn('更新字典数据失败', e);
	}

	if (authRedirecting || getTokenState(localStorage.getItem(TYPES.STAFF_TOKEN)) === 'missing') {
		return;
	}

	store.dispatch("update_staff_info");
	saveScrollPosition(to, from, true);
	next();
})

export default router;
